import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CreateResponsibleOfficialPayload,
  ResponsibleOfficial,
  UpdateResponsibleOfficialPayload,
} from '../../model/responsible-official.model';

export const RESPONSIBLE_OFFICIALS_URL = `${environment.apiBaseUrl}/responsible-officials`;

@Injectable({ providedIn: 'root' })
export class ResponsibleOfficialService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<ResponsibleOfficial[]> {
    return this.http.get<ResponsibleOfficial[]>(RESPONSIBLE_OFFICIALS_URL);
  }

  getById(id: number): Observable<ResponsibleOfficial> {
    return this.http.get<ResponsibleOfficial>(`${RESPONSIBLE_OFFICIALS_URL}/${id}`);
  }

  create(payload: CreateResponsibleOfficialPayload): Observable<ResponsibleOfficial> {
    return this.http.post<ResponsibleOfficial>(RESPONSIBLE_OFFICIALS_URL, payload);
  }

  update(id: number, payload: UpdateResponsibleOfficialPayload): Observable<ResponsibleOfficial> {
    return this.http.put<ResponsibleOfficial>(`${RESPONSIBLE_OFFICIALS_URL}/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${RESPONSIBLE_OFFICIALS_URL}/${id}`);
  }

  verifyOtpAndDelete(email: string, code: string, responsibleOfficialId: number): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/user/otp/verification/responsible-official/delete`,
      { email, code, responsibleOfficialId },
    );
  }
}
